require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./procdure-dadmission-au-master-2-6-2.json") })
        }
      }, "path---procdure-dadmission-au-master-2-6-2");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---procdure-dadmission-au-master-2-6-2!./.cache/json/procdure-dadmission-au-master-2-6-2.json
// module id = 536
// module chunks = 231608221292675